import React from 'react';
import PropTypes from 'prop-types';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Box, Button } from '@mui/material';

const TlForwardBackPagination = ({ links, totalDocs, handleChange }) => {
  const { totalPages, currentPage } = links;

  const prevPage = currentPage > 1 ? currentPage - 1 : 1;
  const nextPage = currentPage < totalPages ? currentPage + 1 : totalPages;

  return (
    totalPages > 0 && (
      <Box className="paginationContent">
        <Box className="totalDocs">
          {totalDocs && (
            <Box>
              {totalDocs.toLocaleString()} {totalDocs === 1 ? 'result' : 'results'}
            </Box>
          )}
        </Box>

        <Box className="forwardBackButtons">
          <Button variant="outlined" onClick={(e) => handleChange(e, prevPage)}>
            <KeyboardArrowLeftIcon className="buttonIcon" />
          </Button>
          <Box className="buttonSeperator" />
          <Button variant="outlined" onClick={(e) => handleChange(e, nextPage)}>
            <KeyboardArrowRightIcon className="buttonIcon" />
          </Button>
        </Box>
      </Box>
    )
  );
};

TlForwardBackPagination.defaultProps = {
  totalDocs: null,
};

TlForwardBackPagination.propTypes = {
  links: PropTypes.shape({
    totalPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  totalDocs: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
};

export default TlForwardBackPagination;
